/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ClientInviteStatus = {
    Created: 1,
    Sent: 2,
    RegistrationFinished: 3
} as const;
export type ClientInviteStatus = typeof ClientInviteStatus[keyof typeof ClientInviteStatus];

